import { Font } from "@/types/fonts";
import defensiveCopy from "@/util/defensive-copy";
import { configStore } from "@/store/store-accessor";

export const addOrUpdateFontInStore = (newFontData: Font) => {
  const newFonts = defensiveCopy(configStore.fonts);
  const index = newFonts.findIndex(font => font.slug === newFontData.slug);

  // Add the new font if it it's new, otherwise replace the existing one
  if (index === -1) {
    newFonts.unshift(newFontData);
  } else {
    newFonts[index] = newFontData;
  }

  configStore.setFonts(newFonts);
};

export const removeFontFromStore = (slug: string) => {
  const newFonts = defensiveCopy(configStore.fonts);
  const index = newFonts.findIndex(font => font.slug === slug);

  if (index > -1) {
    newFonts.splice(index, 1);
  }

  configStore.setFonts(newFonts);
};
